import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import utilityHelper from '../../helpers/helperUtil'
import { Div, Input, DatePicker, Select, DropDownList, CheckerBox, Tablecell, InputDecimal, DatePickerStartEnd } from "../core";
import {
    updateGR_ItemModalAction,
    updateGR_ItemAction,
    updateGR_ServiceAction,
    updateGR_ItemAccountAssignmentAction
} from '../../redux/actions/GRAction'
import {
    updateNewAssetAction
} from '../../redux/actions/MainAction'
import {
    getCostCenterAction,
    getGLAccountAction,
    getMatBatchFlagAction,
    getPlantInfoAction,
    getUOMAction,
    getAssetClassAction
} from '../../redux/actions/MasterAction'
import {
    setAssetModalOptionAction
} from '../../redux/actions/AssetAction'
import {
    setModalCostCenterKeyAction
} from '../../redux/actions/ModalCostCenterAction'
import $ from 'jquery'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import {
    data_t_GR_ITEM,
    data_t_GR_SERVICE,
    data_distribution,
    data_partial_inv,
    data_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
} from '../../configs/datas'
import { msg } from "../Notifications/MsgBox";
import { MessageText } from "../../configs";

import head_acc_assignment_goods_a from './datas/head_acc_assignment_goods_a.json'
import head_acc_assignment_goods_f from './datas/head_acc_assignment_goods_f.json'
import head_acc_assignment_service from './datas/head_acc_assignment_service.json'
import head_acc_assignment_goods_j from './datas/head_acc_assignment_goods_j.json'
import {
    SearchAssetModal,
    SearchIOModal,
    NewAsset
} from '../../components'
import assetHelper from '../../helpers/assetHelper'
import { EVENT_COST_CENTER_SELECTED, 
    EVENT_CURRENT_GRITEM_SELECTED, 
    EVENT_CURRENT_SERVICE_SELECTED 
} from '../../configs/EventTypes'
import tagsConfigHelper from "../../helpers/tagsConfigHelper"


class ItemModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // ...props,
            docType: '',
            showCreateAssetClassType: false,
            showAccountAssignment: true,
            showItem: true,
            order: "asc",
            orderBy: "",
            page: 0,
            rowsPerPage: 5,
            headAccountAssignment: [],
            editQty: false,
            editPerce: false,
            accountAssignment: [],
            itemModal: {},
            gl_account_data: [],
            cost_center_data: [],
            _viewMode: false,
            modalCostCenterKey:"ItemModal",
            gl_accounts_selectList: [],
            matbatchflag:[],
            startdate_SLED_BBD : '',
            enddate_SLED_BBD : '',
            isContract: false,
            isShowMatbatchflag: true,
            _startdate: '',
            _enddate: '',

            plants: [],
            unit_uoms: [],
            assetClasses: [],

        }

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeAccountAssignment = this.handleChangeAccountAssignment.bind(this)
        this.createAssetClassType = this.createAssetClassType.bind(this)
        this.saveItem = this.saveItem.bind(this)
        this.saveAsset=this.saveAsset.bind(this)
        this.goBack = this.goBack.bind(this)
        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.newAccountAssignment = this.newAccountAssignment.bind(this)
        this.getSumAccountAssignment = this.getSumAccountAssignment.bind(this)
        this.getStorageLocation_ByPlant = this.getStorageLocation_ByPlant.bind(this)
        this.openAssetModal = this.openAssetModal.bind(this)
        this.handleSelectAsset = this.handleSelectAsset.bind(this)
        this.handleSelectIO=this.handleSelectIO.bind(this)
        this.openIOModal = this.openIOModal.bind(this)
        this.deleteAccountAssignment = this.deleteAccountAssignment.bind(this)
        this.openCCModal = this.openCCModal.bind(this)
        this.closeModal = this.closeModal.bind(this)

        window.emitter.addListener(EVENT_COST_CENTER_SELECTED,this.handleCostCenterSelected.bind(this) )
        window.emitter.addListener(EVENT_CURRENT_GRITEM_SELECTED, this.setCurrentItemModal.bind(this))
        window.emitter.addListener(EVENT_CURRENT_SERVICE_SELECTED, this.setCurrentItemModal.bind(this))

        
    }

    closeModal(){
        let {showCreateAssetClassType}=this.state

        if(showCreateAssetClassType!==true){
            this.setState({
                itemModal: {
                    index: ""
                }
            })

            window.$('#itemModal').modal('hide')
        }
        else{
            this.goBack()
        }
    }

    getStorageLocation_ByPlant(plantcode) {
        // console.log("getStorageLocation_ByPlant: ", plantcode)
        let result = null
        const { storage_locations } = this.props
        // console.log("storage_locations: ")
        // console.log(storage_locations)

        result = storage_locations && storage_locations.filter(f => f.plant === plantcode)
        if (result) {
            result = utilityHelper.toSelectList(result, "sloC_NAME", "sloc")
        }

        // console.log(result)

        return result
    }


    setCurrentItemModal(data) {

        const { itemDetail,
            setDataItemModal,
            item_gr,
            item_account_assignment_gr,
            service_gr,
            is_contract
        } = data

        let { itemModal } = this.state
        
        let {
            po_no,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICE,
        } = this.props

        itemModal = setDataItemModal

        let accountAssignment = []
        if (itemModal && itemModal.index !== "" && itemModal.type === "item") {
            
            itemModal.item = itemDetail //t_GR_ITEM[itemModal.index]

            item_account_assignment_gr.map((itemACC, index) => {
                if (itemACC.item_no === itemModal.item.item_no) {
                    accountAssignment.push(itemACC)
                }
            })

            if (itemModal.item.distribution === "1") {
                accountAssignment.forEach((data, index) => {
                    data['perce'] = ""

                    if (accountAssignment.length === 1) {
                        data['quantity'] = itemModal.item.receive_qty
                    }
                })
                this.setState({
                    editQty: true,
                    editPerce: false
                })
            } else if (itemModal.item.distribution === "2") {
                accountAssignment.forEach((data, index) => {
                    data['quantity'] = ""
                    if (accountAssignment.length === 1) {
                        data['perce'] = "100"
                    }
                })
                this.setState({
                    editQty: false,
                    editPerce: true
                })
            } else {
                this.setState({
                    editQty: false,
                    editPerce: false
                })
            }

        } else if (itemModal && itemModal.type === "service") {
            this.setState({
                _viewMode: itemModal.viewmode
            })
            itemModal.item = itemDetail //t_GR_SERVICE[itemModal.index]

        } else {
            if (itemModal && itemModal.type === "item") {
                itemModal.item = {
                    ...data_t_GR_ITEM,
                    item_id: (Number(item_gr[item_gr.length - 1].item_id) + 1),
                    item_no: (Number(item_gr[item_gr.length - 1].item_no) + 1),
                    a: item_gr[0].a,
                    i: item_gr[0].i,
                    currency: item_gr[0].currency
                }
            } else if (itemModal && itemModal.type === "service") {
                itemModal.item = {
                    ...data_t_GR_SERVICE,
                    service_item_id: (Number(service_gr[service_gr.length - 1].service_item_id) + 1),
                    service_item_no: (Number(service_gr[service_gr.length - 1].service_item_no) + 1),
                    a: service_gr[0].a,
                    i: service_gr[0].i,
                    currency: service_gr[0].currency
                }
            }
        }

        if (itemModal && itemModal.type === "item") {
            if (itemModal.item.a === 'A') {
                this.setState({
                    headAccountAssignment: head_acc_assignment_goods_a
                })
            } else if (itemModal.item.a === 'F') {
                this.setState({
                    headAccountAssignment: head_acc_assignment_goods_f
                })
            }
            else if (itemModal.item.a === 'J') {
                this.setState({
                    headAccountAssignment: head_acc_assignment_goods_j
                })
            }

            if (itemModal.item.material && itemModal.item.plant) {
                this.props.getMatBatchFlag(itemModal.item.material, itemModal.item.plant, '', '').then(response => {
    
                    const matbatchflag_response = response.data
                    
                    let _startdate = ''
                    let _enddate = ''
    
                    if(matbatchflag_response && matbatchflag_response.length > 0){
    
                        if(matbatchflag_response[0].totaL_SHELF_LIFE == "0" || matbatchflag_response[0].totaL_SHELF_LIFE == null ){
            
                            var autobotrun = matbatchflag_response[0].autoboT_DAY == null ? 1 : Number(matbatchflag_response[0].autoboT_DAY) 
                            var date = Number(autobotrun) + Number(matbatchflag_response[0].miN_REM_SHELF_LIFE)
                            _startdate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + date, 0, 0)).format('YYYY-MM-DD')
    
                        }
                        else if (matbatchflag_response[0].totaL_SHELF_LIFE != "0" && matbatchflag_response[0].totaL_SHELF_LIFE != null) {
            
                            if (itemModal && itemModal.item && itemModal.item.date_of_manufacture) {
            
                                var autobotrun = matbatchflag_response[0].autoboT_DAY == null ? 1 : Number(matbatchflag_response[0].autoboT_DAY) 
                                var datemanufacture = new Date(moment(itemModal.item.date_of_manufacture).format('YYYY-MM-DD'));
                                datemanufacture.setDate(datemanufacture.getDate() + ((Number(autobotrun) + Number(matbatchflag_response[0].totaL_SHELF_LIFE)) - Number(matbatchflag_response[0].miN_REM_SHELF_LIFE)));
                                _enddate = moment(new Date(datemanufacture.getFullYear(), datemanufacture.getMonth(), datemanufacture.getDate(), 0, 0)).format('YYYY-MM-DD')
                            }
                            else{
                                
                                var autobotrun = matbatchflag_response[0].autoboT_DAY == null ? 1 : Number(matbatchflag_response[0].autoboT_DAY) 
                                var datemanufacture = new Date(moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)).format('YYYY-MM-DD'));
                                datemanufacture.setDate(datemanufacture.getDate() + ((Number(autobotrun) + Number(matbatchflag_response[0].totaL_SHELF_LIFE)) - Number(matbatchflag_response[0].miN_REM_SHELF_LIFE)));
                                _enddate = moment(new Date(datemanufacture.getFullYear(), datemanufacture.getMonth(), datemanufacture.getDate(), 0, 0)).format('YYYY-MM-DD')
                            }
                        }
    
                    }
                    console.log("startdate")
                    console.log("enddate")

                    this.setState({
                        matbatchflag: matbatchflag_response,
                        isShowMatbatchflag: matbatchflag_response !== '',
                        _startdate: _startdate,
                        _enddate: _enddate
                    })
    
                }).catch(error => {
                    if (error.message) {
                        msg.error(error.message)
                    }
                })
            }

        } else {
            this.setState({
                headAccountAssignment: head_acc_assignment_service
            })
        }

        let docType = ''

        if (itemModal && itemModal.item) {
            docType = utilityHelper.getDocType(po_no, itemModal.item.a, itemModal.item.i, itemModal.item.material, null)
        }

        this.setState({
            docType: docType,
            itemModal: itemModal,
            accountAssignment: [...accountAssignment],
            _viewMode: itemModal.viewmode,
            headerModal: itemModal.headerModal,
            isContract : is_contract
        })

        this.props.getGLAccount()
            .then((response) => { this.setState({ 
                gl_account_data: response.data,
                gl_accounts_selectList : utilityHelper.toSelectList2(response.data,"shorT_TEXT","gL_ACCOUNT_NO")
            }) })

        $(function () {
            window.onComponentDidMount()
        })

    }

    componentDidMount() {
        // this.props.getCostCenter()
        //     .then((response) => { this.setState({ cost_center_data: response.data }) })

        // this.props.getGLAccount()
        // .then((response) => { this.setState({ 
        //     gl_account_data: response.data,
        //     gl_accounts_selectList : utilityHelper.toSelectList2(response.data,"shorT_TEXT","gL_ACCOUNT_NO")
        // }) })
            

    }

   async handleChange(event, committed) {
        // event.preventDefault()
        //console.group("ItemModal.handleChange()")
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        // console.log("target: ")
        // console.log(target)
        // console.log("name: ", name)
        // console.log("value: ", value)
        // console.log("valid: ", valid)
        // console.groupEnd()

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }
        
        if (name === 'distribution') {
            if (value === "1") {
                this.state.accountAssignment.forEach((data, index) => {
                    if (data.item_no === this.state.itemModal.item.item_no) {
                        // this.props.updateServiceLineModalAccountAssignment("", index, 'perce')
                        this.setState({
                            accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                if (a_index === Number(index)) {
                                    let updateAccountAssignment = data
                                    updateAccountAssignment['perce'] = ""
                                    return updateAccountAssignment
                                } else {
                                    return data
                                }
                            })
                        })

                        if (index === 0) {
                            // this.props.updateServiceLineModalAccountAssignment(this.state.serviceLineModal.item.qty, index, 'quantity')
                            this.setState({
                                accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                    if (a_index === Number(index)) {
                                        let updateAccountAssignment = data
                                        updateAccountAssignment['quantity'] = this.state.itemModal.item.receive_qty
                                        return updateAccountAssignment
                                    } else {
                                        return data
                                    }
                                })
                            })
                            return ""
                        } else {
                            return ""
                        }
                    } else {
                        return ""
                    }
                })
                this.setState({
                    editQty: true,
                    editPerce: false
                })
                if (this.state.itemModal.item.partial_inv === null || this.state.itemModal.item.partial_inv === "Derive from account assignment") {
                    await this.setState({
                        itemModal: {
                            ...this.state.itemModal,
                            item: {
                                ...this.state.itemModal.item,
                                ["partial_inv"]: 2
                            }
                        }
                    })
                }

            } else if (value === "2") {
                this.state.accountAssignment.map((_data, index) => {
                    // this.props.updateServiceLineModalAccountAssignment("", index, 'quantity')
                    this.setState({
                        accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                            if (a_index === Number(index)) {
                                let updateAccountAssignment = data
                                updateAccountAssignment['quantity'] = ""
                                return updateAccountAssignment
                            } else {
                                return data
                            }
                        })
                    })
                    if (index === 0) {
                        // this.props.updateServiceLineModalAccountAssignment("100", index, 'perce')
                        this.setState({
                            accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                if (a_index === Number(index)) {
                                    let updateAccountAssignment = data
                                    updateAccountAssignment['perce'] = "100"
                                    return updateAccountAssignment
                                } else {
                                    return data
                                }
                            })
                        })
                        return ""
                    } else {
                        return ""
                    }
                })
                this.setState({
                    editQty: false,
                    editPerce: true
                })
                if (this.state.itemModal.item.partial_inv === null || this.state.itemModal.item.partial_inv === "Derive from account assignment") {
                    await this.setState({
                        itemModal: {
                            ...this.state.itemModal,
                            item: {
                                ...this.state.itemModal.item,
                                ["partial_inv"]: 2
                            }
                        }
                    })
                }

            } else {
                this.state.accountAssignment.forEach((data, index) => {
                    if (data.item_no === this.state.itemModal.item.item_no) {
                        this.setState({
                            accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                                if (a_index === Number(index)) {
                                    let updateAccountAssignment = data
                                    updateAccountAssignment['perce'] = ""
                                    updateAccountAssignment['quantity'] = ""
                                    return updateAccountAssignment
                                } else {
                                    return data
                                }
                            })
                        })

                    } else {
                        return ""
                    }
                })
             
               await this.setState({
                    itemModal: {
                        ...this.state.itemModal,
                        item: {
                            ...this.state.itemModal.item,
                            ["partial_inv"]: null
                        }
                    }
                })
                this.setState({
                    editQty: false,
                    editPerce: false
                })
            }
        }

        if(name === 'partial_inv' && value == "Derive from account assignment"){
            value = null
        }

        if (name === 'receive_qty') {
            const { itemModal } = this.state
            let { po_no } = this.props
            let is_contract = utilityHelper.checkIsContract(po_no);

            if (itemModal.item) {
                if (is_contract) {
                    if (itemModal.item.po_qty) {
                        let _po_qty = utilityHelper.parseFloat(itemModal.item.po_qty)
                        let _receive_qty = utilityHelper.parseFloat(value)
                        if (_receive_qty <= 0) {
                            msg.error('กรุณาระบุ Receive Qty มากกว่า 0.000')
                        }
                        else if (_receive_qty > _po_qty) {
                            msg.error('Receive Qty มากกว่า PO/Target Qty กรุณาตรวจสอบข้อมูล')
                        }
                        
                    }
                }
                else {
                    if (itemModal.item.remaining_qty) {
                        let _remaining_qty = utilityHelper.parseFloat(itemModal.item.remaining_qty)
                        let _receive_qty = utilityHelper.parseFloat(value)
                        if(_receive_qty <= 0){
                            msg.error('กรุณาระบุ Receive Qty มากกว่า 0.000')
                        }
                        if (_receive_qty > _remaining_qty) {
                            msg.error('Receive Qty มากกว่า Remaining Qty กรุณาตรวจสอบข้อมูล')
                        }
                        else if (_receive_qty < _remaining_qty) {
                            msg.warning('Receive Qty น้อยกว่ายอด Remaining Qty')
                        }
                    }
                }

            }
        }

       let { matbatchflag } = this.state
       if (matbatchflag && matbatchflag.length > 0) {

           if (matbatchflag[0].totaL_SHELF_LIFE != "0" && matbatchflag[0].totaL_SHELF_LIFE != null) {
               if (name == "date_of_manufacture") {
                   await this.setState({
                       itemModal: {
                           ...this.state.itemModal,
                           item: {
                               ...this.state.itemModal.item,
                               ['sled_bbd']: null
                           }
                       }
                   })
               }
           }
       }

       if (valid) {
           this.setState({
               itemModal: {
                   ...this.state.itemModal,
                   item: {
                       ...this.state.itemModal.item,
                       [name]: value
                   }
               }
           })

       } else {
           return
       }
        // }
    }

    handleChangeAccountAssignment(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }
        // let { accountAssignment } = this.state  
        if (valid) {
            this.setState({
                accountAssignment: this.state.accountAssignment.map((data, a_index) => {
                    if (a_index === Number(index)) {
                        let updateAccountAssignment = {...data}
                        updateAccountAssignment[name] = value
                        return updateAccountAssignment
                    } else {
                        return {...data}
                    }
                })
            })
        } else {
            return
        }
    }

    async saveItem() {
        let IsCheckAccsignment = false
        var tagInfo = tagsConfigHelper.findTagConfig("gr.head.account_assignment", this.state.docType)
        if (tagInfo) {
            IsCheckAccsignment = tagInfo.visibled
        }

        const {t_PO_DETAIL} = this.props
        let isCheckPo = false
        if(t_PO_DETAIL.po_contract_no.substr(0,2) === "41" || t_PO_DETAIL.po_contract_no.substr(0,3) === "322" || t_PO_DETAIL.po_contract_no.substr(0,3) === "324"){
            isCheckPo = true
        }
        

        const {itemModal, accountAssignment, matbatchflag} = this.state
        let checkAcc = false
        let checkAccMsg = ""
        let _qty = 0
        let _perce = 0
        if (IsCheckAccsignment) {
            accountAssignment && accountAssignment.map((acc, index) => {
                if (itemModal.item.a === "A" && (!acc.asset || acc.asset === "") && isCheckPo) {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ Asset Seq. " + acc.acc_id + "<br/>"
                }
                if (!acc.acc_order || acc.acc_order === "") {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ Order Seq. " + acc.acc_id + "<br/>"
                }
                if (itemModal.item.a === "F" && (!acc.gl_acct || acc.gl_acct === "")) {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ GL Seq. " + acc.acc_id + "<br/>"
                }
                if (itemModal.item.a === "F" && (!acc.cost_center || acc.cost_center === "") && (acc.acc_order && acc.acc_order.length !== 9) && isCheckPo) {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ Cost Center Seq. " + acc.acc_id + "<br/>"
                }
                if (
                    (!acc.quantity || acc.quantity === "" || acc.quantity === "0.000" || acc.quantity === 0.000)
                    && itemModal.item.distribution === "1"
                ) {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ Quantity Seq. " + acc.acc_id + "<br/>"
                }
                if (
                    (!acc.perce || acc.perce === "" || acc.perce === "0.000" || acc.perce === 0.000)
                    && itemModal.item.distribution === "2"
                ) {
                    checkAcc = true
                    checkAccMsg = checkAccMsg + "กรุณาระบุ Quantity Seq. " + acc.acc_id + "<br/>"
                }
                _qty += utilityHelper.parseFloat(acc.quantity)
                _perce += utilityHelper.parseFloat(acc.perce)
            })
        }

        let _checkBatch = ""
        let _checkQty = null
        if (itemModal.type === "item") {
            
            var tagInfoStorageLocation = tagsConfigHelper.findTagConfig("gr.item.storage_location", this.state.docType)
            if (tagInfoStorageLocation) {
                if(tagInfoStorageLocation.required){
                    if (itemModal.item.storage_location === null){
                        _checkQty = "กรุณาตรวจสอบข้อมูล Storage Location <br/>"
                    }
                }
            }

            let numeral = require('numeral');
            const _po = this.props.t_PO_DETAIL.po_contract_no.substr(0, 2)
            if (_po === "41" && itemModal.item.distribution === "1") {
                if (numeral(_qty).format('0.000') !== numeral(itemModal.item.receive_qty).format('0.000')) {
                    _checkQty = "กรุณาตรวจสอบข้อมูลผลรวม Quantity มีค่าไม่เท่ากับ Receive Qty<br/>"
                }
            } else if (_po === "41" && itemModal.item.distribution === "2") {
                if (numeral(_perce).format('0.00') !== "100.00") {
                    _checkQty = "กรุณาตรวจสอบข้อมูลผลรวม Perce มีค่าไม่เท่ากับ 100<br/>"
                }
            }
            
            if (_po === "41" && (itemModal.item.distribution !== "1" && itemModal.item.distribution !== "2") && this.state.accountAssignment.length > 1) {
                _checkQty = "ไม่สามารถมี Account Assingment มากกว่า 1 ได้<br/>"
            }

            if((itemModal.item.distribution === "Single account assignment" || itemModal.item.distribution === null) && (itemModal.item.partial_inv === "1" || itemModal.item.partial_inv === "2")){
                _checkQty = "กรุณาตรวจสอบ Partial Inv.<br/>"
            }

            if((itemModal.item.distribution === "1" || itemModal.item.distribution === "2") && (itemModal.item.partial_inv === null || itemModal.item.partial_inv === "Derive from account assignment")){
                _checkQty = "กรุณาตรวจสอบ Partial Inv.<br/>"
            }

            if(matbatchflag && matbatchflag.length > 0){

                if (itemModal.item.batch == "" || itemModal.item.batch == null) {
                    _checkBatch = _checkBatch + "กรุณาระบุ Batch <br/>"
                }
                if (matbatchflag[0].totaL_SHELF_LIFE == "0" || matbatchflag[0].totaL_SHELF_LIFE == null) {
                    if (itemModal.item.sled_bbd =="" || itemModal.item.sled_bbd == null) {
                        _checkBatch = _checkBatch + "กรุณาระบุ SLED BBD <br/>"
                    }
                }
                else if (matbatchflag[0].totaL_SHELF_LIFE != "0" || matbatchflag[0].totaL_SHELF_LIFE != null) {
                    if (itemModal.item.date_of_manufacture =="" || itemModal.item.date_of_manufacture == null) {
                        _checkBatch = _checkBatch + "กรุณาระบุ Date of Manufacture <br/>"
                    }
                }
            }

        }

        if (checkAcc) {
            msg.error(checkAccMsg)
        }
        else if (_checkQty !== null) {
            msg.error(_checkQty)
        }   
        else if (_checkBatch !== "") {
            msg.error(_checkBatch)
        }
        else {
            if (this.state.itemModal.type === 'item') {

                if (this.state.itemModal.index === "") {
                    this.props.updateGR_Item(this.state.itemModal.item)
                } else {
                    this.props.updateGR_Item(this.state.itemModal.item, this.state.itemModal.index)
                }

            } else if (this.state.itemModal.type === 'service') {
                if (this.state.itemModal.index === "") {
                    this.props.updateGR_Service(this.state.itemModal.item)
                } else {
                    this.props.updateGR_Service(this.state.itemModal.item, this.state.itemModal.index)
                }
            }


            if (this.state.accountAssignment.length > 0) {
                await this.props.updateGR_ItemAccountAssignment("remove", this.state.itemModal.item.item_no)
                this.state.accountAssignment.map((item, _index) => {
                    this.props.updateGR_ItemAccountAssignment(item)
                })
            }

            this.setState({
                itemModal: {
                    index: ""
                }
            })

            window.$('#itemModal').modal('hide');
        }
    }

   async saveAsset(assetNew) {
        const {
            accountAssignment,
            itemModal
        }=this.state
        const {t_NEW_ASSET}=this.props

        let accountAssignmentUpdated=[...accountAssignment]
   
        if(!assetNew)return

        //Validations
        let start=1
        let qty=1

        if(assetNew.start_sequence && assetNew.start_sequence.length>0) {
            start=parseInt(assetNew.start_sequence)
        }

        if(assetNew.no_of_similar_asset && assetNew.no_of_similar_asset.length>0){
            qty=parseInt(assetNew.no_of_similar_asset)
        }

        if(qty < 1) {
            msg.error(MessageText.PAGE.ASSET.MSG_NO_OF_SIMILAR_INVALID_ZERO)
            return
        }

        if (start < 1 || start > (accountAssignment.length+1)){
            msg.error(MessageText.PAGE.ASSET.MSG_START_SEQUENCE_INVALID)
            return
        }
        //End of Validations
        
        let assetResult=assetHelper.generateAssets(assetNew,[...t_NEW_ASSET])
        let defaultOrder=null

        if(accountAssignmentUpdated && accountAssignmentUpdated.length>0){
            defaultOrder=accountAssignmentUpdated[0].acc_order
        }


        for(let i=0;i<qty;i++){
            let asset_index=(start-1)+i
            let asset=assetResult.assets_New[i]

            if(asset_index> accountAssignment.length-1){
                let acc_id = utilityHelper.parseInt(Math.max.apply(Math, accountAssignmentUpdated.map(function(o) { return o.acc_id; }))) + 1
                let newAccountAssignment={...data_t_GR_ITEM_ACCOUNT_ASSIGNMENT[0],
                    item_no: itemModal.item.item_no,
                    sequence: acc_id,
                    acc_id: acc_id,
                    asset : asset.asset_no,
                    asset_no : asset.asset_no,
                    acc_order : defaultOrder,
                    asset_creation_flag : true
                }
                
                accountAssignmentUpdated.push(newAccountAssignment)
            }else{
                accountAssignmentUpdated[asset_index].asset=asset.asset_no
                accountAssignmentUpdated[asset_index].asset_no=asset.asset_no
                accountAssignmentUpdated[asset_index].acc_order=defaultOrder
                accountAssignmentUpdated[asset_index].asset_creation_flag=true
            }
        }

       await this.setState({
            accountAssignment: accountAssignmentUpdated,
            showAccountAssignment: true,
            showItem: true,
            showCreateAssetClassType: false
        })
      
        this.props.updateNewAsset(assetResult.assets_All)
    }

    async createAssetClassType() {
       await this.props.setAssetModalOption({
            poType : 'goods'
        })

        window.$('#itemModal').animate({scrollTop:0}, 'slow');

        this.setState({
            showAccountAssignment: false,
            showItem: false,
            showCreateAssetClassType: true
        })

        this.props.getAssetClass().then(response => {
            let result = utilityHelper.toSelectList(response.data, "display", "value")
            this.setState({ assetClasses: result })
        })

         this.props.getPlantInfo(null).then(response => {
            let result = utilityHelper.toSelectList_CombineFields(response.data, "planT_CODE", "planT_DESC", "planT_CODE")
            this.setState({ plants: result })
        })

        this.props.getUOM().then(response => {
            let result = utilityHelper.toSelectList_CombineFields(response.data, "commercial", "uniT_TEXT", "commercial")
            this.setState({ unit_uoms: result })
        })
 
    }

    goBack() {
        if (this.state.showCreateAssetClassType) {
            this.setState({
                showAccountAssignment: true,
                showItem: true,
                showCreateAssetClassType: false
            })
        }
    }

    getSumAccountAssignment() {
        let count = 0
        this.state.accountAssignment.map((item) => {
            if (item.item_no === this.state.itemModal.item.item_no) {
                count = count + 1
            }
            return ""
        })
        return count
    }

    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy === property && this.state.order === "desc";
        this.setState({
            order: isDesc ? "asc" : "desc",
            orderBy: property
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage: +event.target.value,
            page: 0
        })
    }

    newAccountAssignment() {
        //const { t_GR_ITEM_ACCOUNT_ASSIGNMENT } = this.props
        //let newData = t_GR_ITEM_ACCOUNT_ASSIGNMENT[0]
        
        let acc_id = utilityHelper.parseInt(Math.max.apply(Math, this.state.accountAssignment.map(function(o) { return o.acc_id; }))) + 1
        let newData = {
            ...this.state.accountAssignment[0],
            item_no: this.state.itemModal.item.item_no,
            sequence: acc_id,
            acc_id: acc_id,
            asset:"",
            quantity:"",
            perce:""
        }
        this.state.accountAssignment.push(newData)
        //this.props.updateGR_ItemAccountAssignment(newData)
        this.setState({
            accountAssignment:[
                ...this.state.accountAssignment
            ]
        })
    }

    deleteAccountAssignment(item_no, acc_id) {
       
        this.setState({
            accountAssignment:[
                ...this.state.accountAssignment.filter(f=>f.item_no === item_no && f.acc_id !== acc_id)
            ]
        })    
        
        this.props.updateGR_ItemAccountAssignment("removeOne", item_no, acc_id)
    }

    // Grid end

    openAssetModal(event, index) {
        
        this.setState({
            editIndex: index,
            //ctrObj:event
        })

        window.$('#searchAssetModal').modal('show');
    }

    openIOModal(event, index) {
        
        this.setState({
            editIndex: index,
            //ctrObj:event
        })
        window.$('#searchIOModal').modal('show');
    }

    openCCModal(event, index) {
        
     const{modalCostCenterKey}=this.state

        this.setState({
            editIndex: index,
            //ctrObj:event
        })
       
        this.props.setModalCostCenterKey(modalCostCenterKey)
        window.$('#searchCostCenterModal').modal('show');
    }

    handleCostCenterSelected(refKey,obj) {
        let { 
            editIndex, 
            accountAssignment,
            modalCostCenterKey 
        } = this.state
        //event.preventDefault()
        
        let value = obj;
        const index = editIndex

        if(modalCostCenterKey !==refKey)return

        if (value) {
            //console.log("handleSelectIO")

            this.setState({

                accountAssignment:
                    accountAssignment.map((data, index_state) => {
                        if (index_state == index) {
                            let updateItem = {...data}
                            updateItem.cost_center = value
                            return updateItem
                        } else {
                            return data
                        }
                    })
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    handleSelectAsset(value) {
        //console.log("handleChangeAccountAssignment")
        let { editIndex, accountAssignment } = this.state
        //event.preventDefault()
       
        const index = editIndex

        if (value) {
            //console.log("handleSelectAsset")

            let updateItem={...accountAssignment[index]}

            if(value.indexOf("NEW")!=-1){
                //new asset
                updateItem.asset_creation_flag=true
                updateItem.asset=value
                updateItem.asset_no=value
            }else{
                updateItem.asset_creation_flag=false
                updateItem.asset=value
            }

            accountAssignment[index]=updateItem

            this.setState({
                accountAssignment: accountAssignment
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    handleSelectIO(obj) {
        //console.log("handleSelectIO")
        let { editIndex, accountAssignment } = this.state
        //event.preventDefault()
       
        let value = obj;
        const index = editIndex

        if (value) {
            //console.log("handleSelectIO")

            this.setState({

                accountAssignment:
                    accountAssignment.map((data, index_state) => {
                        if (index_state == index) {
                            let updateItem = {...data}
                            updateItem.acc_order = value
                            if(value.length === 9){
                                updateItem.cost_center = ""
                            }
                            return updateItem
                        } else {
                            return data
                        }
                    })
            })
            //this.props.updateGR_ServiceAccountAssignment(value, index, name)

        } else {
            return
        }
    }

    

    render() {
        //console.log("ItemModal.render()")
        const {
            docType,
            itemModal,
            showCreateAssetClassType,
            _viewMode,
            gl_accounts_selectList,
            headerModal,
            matbatchflag,
            isShowMatbatchflag,
            
        } = this.state

        let {
            _startdate,
            _enddate
        } = this.state

        const {
            po_no
        } = this.props

        let { viewMode } = this.props
        viewMode = _viewMode ? true : viewMode

        let headModalText = showCreateAssetClassType !== true ? headerModal : "Create Asset"

        const numeral = require('numeral');
        const createSortHandler = property => event => {
            this.handleRequestSort(event, property);
        };

        let isRequired_SLED_BBD = false
        let isRequired_date_of_manufacture = true
        let getSeconds = ''

        if(matbatchflag && matbatchflag.length > 0){

            if(matbatchflag[0].totaL_SHELF_LIFE == "0" || matbatchflag[0].totaL_SHELF_LIFE == null ){
                
                isRequired_SLED_BBD = true
                isRequired_date_of_manufacture = false

                var autobotrun = matbatchflag[0].autoboT_DAY == null ? 1 : Number(matbatchflag[0].autoboT_DAY) 
                var date = Number(autobotrun) + Number(matbatchflag[0].miN_REM_SHELF_LIFE)
                _startdate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + date, 0, 0)).format('YYYY-MM-DD')

            }
            else if (matbatchflag[0].totaL_SHELF_LIFE != "0" && matbatchflag[0].totaL_SHELF_LIFE != null) {
                
                isRequired_date_of_manufacture = true
                isRequired_SLED_BBD = false

                if (itemModal && itemModal.item && itemModal.item.date_of_manufacture) {
            
                    var autobotrun = matbatchflag[0].autoboT_DAY == null ? 1 : Number(matbatchflag[0].autoboT_DAY) 
                    var datemanufacture = new Date(moment(itemModal.item.date_of_manufacture).format('YYYY-MM-DD'));
                    datemanufacture.setDate(datemanufacture.getDate() + ((Number(autobotrun) + Number(matbatchflag[0].totaL_SHELF_LIFE)) - Number(matbatchflag[0].miN_REM_SHELF_LIFE)));
                    _enddate = moment(new Date(datemanufacture.getFullYear(), datemanufacture.getMonth(), datemanufacture.getDate(), 0, 0)).format('YYYY-MM-DD')
                }
                else{
                    
                    var autobotrun = matbatchflag[0].autoboT_DAY == null ? 1 : Number(matbatchflag[0].autoboT_DAY) 
                    var datemanufacture = new Date(moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)).format('YYYY-MM-DD'));
                    datemanufacture.setDate(datemanufacture.getDate() + ((Number(autobotrun) + Number(matbatchflag[0].totaL_SHELF_LIFE)) - Number(matbatchflag[0].miN_REM_SHELF_LIFE)));
                    _enddate = moment(new Date(datemanufacture.getFullYear(), datemanufacture.getMonth(), datemanufacture.getDate(), 0, 0)).format('YYYY-MM-DD')
                }

            }

        }

        // console.log("startdate")
        // console.log(_startdate)
        // console.log("enddate")
        // console.log(_enddate)

        return (
            
            <div className="modal fade sp-modal rrs-modal" id="itemModal" tabIndex={-1} role="dialog" aria-labelledby="itemModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemModalLabel">{headModalText}</h5>
                            <button type="button" className="close"  onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {itemModal && itemModal.item && (<div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div className="row align-items-center mx-0">
                                    <div className="col-md-6 col-lg-4 pr-md-5 pl-0">
                                        Purchase Order PO / Contract Number : {po_no}
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                        <div className="form-inline">
                                            <div className="col-auto pl-0"><label className="rrs-detail-label mb-md-0" htmlFor="sp-input1">Item Number :</label></div>
                                            <div className="rrs-detail-data">
                                                {itemModal.item.item_no ? itemModal.item.item_no :
                                                    (itemModal.item.service_item_no ? itemModal.item.service_item_no : "")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.showItem && (<div id="div_itemInfo" className="rrs-detail">
                                    <div className="showhide-detail-button">
                                        <a className="btn-showhide-detail header-item-info" data-toggle="collapse" href="#collapseItemInfo" role="button" aria-expanded="false" aria-controls="collapseItemInfo">
                                            <i className="icon icon-circle-up" /><span> Item Information</span>
                                        </a>
                                    </div>

                                    <div className="collapse show" id="collapseItemInfo">
                                        <div className="rrs-detail pt-2 pb-3 px-3 item-information">
                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.a" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="account_assignment" id="lbl-gr_item_a" className="rrs-label">Account Assignment</label>
                                                        <div className="rrs-detail-data" >
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.a}`}
                                                                type="text"
                                                                name="a"
                                                                maxlength="1"
                                                                defaultValue={itemModal.item.a || ''}
                                                                id="account_assignment"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.a"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.i" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="item_category" id="lbl-gr_item_i" className="rrs-label">Item Category</label>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.i}`}
                                                                type="text"
                                                                name="i"
                                                                maxlength="1"
                                                                defaultValue={itemModal.item.i || ''}
                                                                id="item_category"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.i"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.material" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="material" id="lbl-gr_item_material" className="rrs-label">Material </label>
                                                        <div className="rrs-detail-data" >

                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.material}`}
                                                                doctype={docType}
                                                                tagid="gr.item.material"
                                                                type="text"
                                                                name="material"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.material || ''}
                                                                className="form-control"
                                                                id="material"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                maxlength="9"
                                                                floatingPoint={0}
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.short_text" >
                                                    <div className="rrs-form">
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <label htmlFor="short_text" id="lbl-gr_item_short_text" className="rrs-label">Short Text </label>
                                                        <div className="rrs-detail-data" >
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.short_text}`}
                                                                type="text"
                                                                name="short_text"
                                                                maxlength="40"
                                                                defaultValue={itemModal.item.short_text || ''}
                                                                className="short_text"
                                                                id="short_text"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.short_text"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.order_unit" >
                                                    <div className="rrs-form">
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <label htmlFor="order_unit" id="lbl-gr_item_order_unit" className="rrs-label">Unit </label>
                                                        <div className="rrs-detail-data" >
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.order_unit}`}
                                                                type="text"
                                                                name="order_unit"
                                                                defaultValue={itemModal.item.order_unit || ''}
                                                                className="order_unit"
                                                                id="order_unit"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.order_unit"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.requisitioner" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="requisitioner" id="lbl-gr_item_requisitioner" className="rrs-label">Requisitioner </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_requisitioner" className="rrs-label">(รหัสหน่วยงานผู้ต้องการพัสดุ/บริการ)</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.requisitioner}`}
                                                                doctype={docType}
                                                                tagid="gr.item.requisitioner"
                                                                type="text"
                                                                name="requisitioner"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.requisitioner || ''}
                                                                className="form-control"
                                                                id="requisitioner"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                maxlength="8"
                                                                floatingPoint={0}
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.po_qty" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="po_qty" id="lbl-gr_item_po_qty" className="rrs-label">PO/Target Qty </label>
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <div className="rrs-detail-data ">
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.po_qty}`}
                                                                doctype={docType}
                                                                tagid="gr.item.po_qty"
                                                                type="text"
                                                                name="po_qty"
                                                                pattern="[0-9]*"
                                                                defaultValue={numeral(itemModal.item.po_qty).format('0,0.000')}
                                                                className="form-control text-right"
                                                                id="po_qty"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                step="0,0.000"
                                                                floatingPoint={3}
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.remaining_qty">
                                                    <div className="rrs-form">
                                                        <label htmlFor="remaining_qty" id="lbl-gr_item_remaining_qty" className="rrs-label">Remaining Qty </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_remaining_qty" className="rrs-label">(ปริมาณคงเหลือที่ทำรับได้)</label>
                                                        </div>
                                                        <div className="rrs-detail-data text-right" >
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.remaining_qty}`}
                                                                doctype={docType}
                                                                tagid="gr.item.remaining_qty"
                                                                type="text"
                                                                name="remaining_qty"
                                                                pattern="[0-9]*"
                                                                defaultValue={numeral(itemModal.item.remaining_qty).format('0,0.000')}
                                                                className="form-control text-right"
                                                                id="remaining_qty"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                step="0,0.000"
                                                                floatingPoint={3}
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.receive_qty">
                                                    <div className="rrs-form">
                                                        <label htmlFor="receive_qty" id="lbl-gr_item_receive_qty" className="rrs-label">Receive Qty </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_receive_qty" className="rrs-label">(ปริมาณที่ต้องการทำรับ)</label>
                                                        </div>
                                                        <div className="rrs-detail-data text-right">
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.receive_qty}`}
                                                                tagid="gr.item.receive_qty"
                                                                doctype={docType}
                                                                type="text"
                                                                name="receive_qty"
                                                                pattern="[0-9.,]*"
                                                                defaultValue={itemModal.item.receive_qty ? (numeral(itemModal.item.receive_qty).format('0,0.000')) : ""}
                                                                className="form-control text-right"
                                                                id="receive_qty"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                step="0,0.000"
                                                                floatingPoint={3}
                                                                viewMode={viewMode}
                                                                validate_required={false}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.pr_no">
                                                    <div className="rrs-form">
                                                        <label htmlFor="pr_no" id="lbl-gr_item_pr_no" className="rrs-label">PR No </label>
                                                        <div className="rrs-detail-data text-right">
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.pr_no}`}
                                                                doctype={docType}
                                                                tagid="gr.item.pr_no"
                                                                type="text"
                                                                id="pr_no"
                                                                name="pr_no"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.pr_no || ''}
                                                                className="form-control "
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                maxlength="10"
                                                                floatingPoint={0}
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.pr_item" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="pr_item" id="lbl-gr_item_pr_item" className="rrs-label">PR Item </label>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.pr_item}`}
                                                                type="text"
                                                                name="pr_item"
                                                                defaultValue={itemModal.item.pr_item || ''}
                                                                className="pr_item"
                                                                id="pr_item"
                                                                onBlur={this.handleChange}
                                                                maxlength="25"
                                                                doctype={docType}
                                                                tagid="gr.item.pr_item"
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.contract_item_no" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="contract_no" id="lbl-gr_item_contract_item_no" className="rrs-label">Outline Agreement No </label>
                                                        <div className="rrs-detail-data" >
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.contract_no}`}
                                                                type="text"
                                                                id="contract_no"
                                                                name="contract_no"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.contract_no || ''}
                                                                className="form-control "
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                maxlength="10"
                                                                floatingPoint={0}
                                                                doctype={docType}
                                                                tagid="gr.item.contract_item_no"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.contract_item" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="contract_item" id="lbl-gr_item_contract_item" className="rrs-label">Outline Agreement Item </label>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.contract_item}`}
                                                                type="text"
                                                                name="contract_item"
                                                                defaultValue={itemModal.item.contract_item || ''}
                                                                className="form-control"
                                                                id="contract_item"
                                                                maxlength="25"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.contract_item"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.delivery_date" >
                                                    <div className="rrs-form">
                                                        <div key={`itemModal_${itemModal.item.item_no}_${itemModal.item.delivery_date}`}>
                                                            <label htmlFor="delivery_date" id="lbl-gr_item_delivery_date" className="rrs-label"><span className="required">*</span> Delivery Date </label>
                                                            <div className="rrs-detail-data">
                                                                <label htmlFor="cc" id="lblsub-gr_item_delivery_date" className="rrs-label">(กำหนดส่งมอบ)</label>
                                                            </div>
                                                        </div>
                                                        <div className="rrs-detail-data" >
                                                            <DatePicker
                                                                value={itemModal.item.delivery_date
                                                                    ? moment(itemModal.item.delivery_date).format('DD/MM/YYYY')
                                                                    : ""}
                                                                name="delivery_date"
                                                                id="delivery_date"
                                                                onChange={this.handleChange}
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.delivery_date"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.net_price" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="net_price" id="lbl-gr_item_net_price" className="rrs-label">Net Price </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_net_price" className="rrs-label">(ราคาสั่งซื้อ)</label>
                                                        </div>
                                                        <div className="rrs-detail-data" >
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.net_price}`}
                                                                type="text"
                                                                id="net_price"
                                                                name="net_price"
                                                                pattern="[0-9.,]*"
                                                                defaultValue={numeral(itemModal.item.net_price).format('0,0.00')}
                                                                className="form-control text-right "
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                floatingPoint={2}
                                                                step="0,0.00"
                                                                doctype={docType}
                                                                tagid="gr.item.net_price"
                                                                viewMode={viewMode}
                                                            />

                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.currency" >
                                                    <div className="rrs-form">
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <label htmlFor="currency" id="lbl-gr_item_currency" className="rrs-label">Currency </label>
                                                        <div className="rrs-detail-data">
                                                            <Select
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.currency}`}
                                                                name="currency"
                                                                value={itemModal.item.currency || ''}
                                                                className="form-control-small currency"
                                                                id="currency"
                                                                onChange={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.currency"
                                                                viewMode={viewMode}
                                                            >
                                                                {this.props.currency_code_data && this.props.currency_code_data.map((currencyCodeData, index) => (
                                                                    // <option key={index} value={businessData.BUSINESS_PLACE}>{businessData.DESCRIPTION}</option>
                                                                    <option key={index} value={currencyCodeData.currencY_CODE}>{currencyCodeData.currencY_CODE}</option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.per" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="per" id="lbl-gr_item_per" className="rrs-label">Per </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_per" className="rrs-label">(ต่อจำนวนหน่วย)</label>
                                                        </div>
                                                        <div className="rrs-detail-data" >
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.per}`}
                                                                type="text"
                                                                id="per"
                                                                name="per"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.per || ''}
                                                                className="form-control"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                maxlength="5"
                                                                floatingPoint={0}
                                                                doctype={docType}
                                                                tagid="gr.item.per"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.opu" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="opu" id="lbl-gr_item_opu" className="rrs-label">OPU </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_opu" className="rrs-label">(หน่วยนับในการกำหนดราคา)</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.opu}`}
                                                                type="text"
                                                                name="opu"
                                                                defaultValue={itemModal.item.opu || ''}
                                                                className="opu"
                                                                id="opu"
                                                                maxlength="3"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.opu"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.material_group">
                                                    <div className="rrs-form">
                                                        <label htmlFor="material_group" id="lbl-gr_item_material_group" className="rrs-label">Material Group </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_material_group" className="rrs-label">(กลุ่มพัสดุ)</label>
                                                        </div>
                                                        <div className="rrs-detail-data" >
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.material_group}`}
                                                                type="text"
                                                                name="material_group"
                                                                defaultValue={itemModal.item.material_group || ''}
                                                                className="material_group"
                                                                id="material_group"
                                                                maxlength="9"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.material_group"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.plant" >
                                                    <div className="rrs-form">
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <label htmlFor="plant" id="lbl-gr_item_plant" className="rrs-label">Plant </label>
                                                        <div className="rrs-detail-data" >
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.plant}`}
                                                                type="text"
                                                                id="plant"
                                                                name="plant"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.plant || ''}
                                                                className="form-control"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                floatingPoint={0}
                                                                doctype={docType}
                                                                tagid="gr.item.plant"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.storage_location">
                                                    <div className="rrs-form">
                                                        <label htmlFor="storage_location" id="lbl-gr_item_storage_location" className="rrs-label">Storage Location</label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_storage_location" className="rrs-label">(คลังพัสดุย่อย)</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <DropDownList
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.storage_location}`}
                                                                name="storage_location"
                                                                options={this.getStorageLocation_ByPlant(itemModal.item.plant)}
                                                                onSelectChanged={this.handleChange}
                                                                selected={itemModal.item.storage_location}
                                                                doctype={docType}
                                                                tagid="gr.item.storage_location"
                                                                viewMode={viewMode}
                                                            >
                                                            </DropDownList>
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.storage_bin" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="storage_bin" id="lbl-gr_item_storage_bin" className="rrs-label">Storage Bin</label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_storage_bin" className="rrs-label">(สถานที่เก็บพัสดุ)</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.storage_bin}`}
                                                                type="text"
                                                                name="storage_bin"
                                                                defaultValue={itemModal.item.storage_bin || ''}
                                                                className="storage_bin"
                                                                id="storage_bin"
                                                                maxlength="10"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.storage_bin"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            <div className="row">
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.goods_recipient" >
                                                    <div className="rrs-form">
                                                        <label htmlFor="goods_recipient" id="lbl-gr_item_goods_recipient" className="rrs-label">Goods Recipient </label>
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="cc" id="lblsub-gr_item_goods_recipient" className="rrs-label">(รหัสผู้รับพัสดุ/งาน)</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <InputDecimal
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.goods_recipient}`}
                                                                tagid="gr.item.goods_recipient"
                                                                doctype={docType}
                                                                type="text"
                                                                name="goods_recipient"
                                                                pattern="[0-9]*"
                                                                defaultValue={itemModal.item.goods_recipient || ''}
                                                                className="form-control"
                                                                id="goods_recipient"
                                                                onBlur={this.handleChange}
                                                                inputMode="decimal"
                                                                floatingPoint={0}
                                                                maxlength="6"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.unloading_point">
                                                    <div className="rrs-form">
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <label htmlFor="unloading_point" id="lbl-gr_item_unloading_point" className="rrs-label">Unloading Point </label>
                                                        <div className="rrs-detail-data">
                                                            <Input
                                                                key={`itemModal_${itemModal.item.item_no}_${itemModal.item.unloading_point}`}
                                                                type="text"
                                                                maxlength="25"
                                                                name="unloading_point"
                                                                defaultValue={itemModal.item.unloading_point || ''}
                                                                className="unloading_point"
                                                                id="unloading_point"
                                                                onBlur={this.handleChange}
                                                                doctype={docType}
                                                                tagid="gr.item.unloading_point"
                                                                viewMode={viewMode}
                                                            />
                                                        </div>
                                                    </div>
                                                </Div>
                                                <Div className="col-md-4" doctype={docType} tagid="gr.item.final">
                                                    <div className="rrs-form">
                                                        <label htmlFor="final" className="rrs-label">&nbsp;</label>
                                                        <div className="rrs-detail-data content-hide">
                                                            <label htmlFor="cc" className="rrs-label">|</label>
                                                        </div>
                                                        <div className="rrs-detail-data">
                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                    <CheckerBox
                                                                        key={`itemModal_${itemModal.item.item_no}`}
                                                                        name="final"
                                                                        text="งวดสุดท้าย"
                                                                        checked={itemModal.item.final == 1}
                                                                        onChange={this.handleChange}
                                                                        doctype={docType}
                                                                        tagid="gr.item.final"
                                                                        viewMode={viewMode}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Div>
                                            </div>

                                            {(isShowMatbatchflag) && (
                                                <div className="row">
                                                    <Div className="col-md-4" doctype={docType} tagid="gr.item.batch" >
                                                        <div className="rrs-form">
                                                            <span className="required">*</span> <label htmlFor="batch" className="rrs-label" id="lbl-gr_item_batch">Batch </label>
                                                            <div className="rrs-detail-data">
                                                                <Input
                                                                    key={`itemModal_${itemModal.item.item_no}_${itemModal.item.batch}`}
                                                                    type="text"
                                                                    name="batch"
                                                                    defaultValue={itemModal.item.batch || ''}
                                                                    className="batch"
                                                                    id="batch"
                                                                    maxlength="10"
                                                                    onBlur={this.handleChange}
                                                                    doctype={docType}
                                                                    tagid="gr.item.batch"
                                                                    viewMode={viewMode}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Div>
                                                    <Div className="col-md-4" doctype={docType} tagid="gr.item.vendor_batch" >
                                                        <div className="rrs-form">
                                                            <label htmlFor="vendor_batch" className="rrs-label" id="lbl-gr_item_vendor_batch">Vendor Batch </label>
                                                            <div className="rrs-detail-data">
                                                                <Input
                                                                    key={`itemModal_${itemModal.item.item_no}_${itemModal.item.vendor_batch}`}
                                                                    type="text"
                                                                    name="vendor_batch"
                                                                    defaultValue={itemModal.item.vendor_batch || ''}
                                                                    className="vendor_batch"
                                                                    id="vendor_batch"
                                                                    maxlength="15"
                                                                    onBlur={this.handleChange}
                                                                    doctype={docType}
                                                                    tagid="gr.item.vendor_batch"
                                                                    viewMode={viewMode}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Div>
                                                    <Div className="col-md-4" doctype={docType} tagid="gr.item.date_of_manufacture" >
                                                        <div className="rrs-form">
                                                            <div key={`itemModal_${itemModal.item.item_no}_${itemModal.item.date_of_manufacture}`}>
                                                                {isRequired_date_of_manufacture == true ? <span className="required">* </span> : '' }<label htmlFor="date_of_manufacture" className="rrs-label" id="lbl-gr_item_date_of_manufacture">Date of Manufacture </label>
                                                            </div>
                                                            <div className="rrs-detail-data">
                                                                <DatePicker
                                                                    value={itemModal.item.date_of_manufacture
                                                                        ? moment(itemModal.item.date_of_manufacture).format('DD/MM/YYYY')
                                                                        : ""}
                                                                    name="date_of_manufacture"
                                                                    id="date_of_manufacture"
                                                                    onChange={this.handleChange}
                                                                    onBlur={this.handleChange}
                                                                    doctype={docType}
                                                                    tagid="gr.item.date_of_manufacture"
                                                                    viewMode={viewMode}
                                                                    readOnly={true}
                                                                    
                                                                />

                                                            </div>
                                                        </div>
                                                    </Div>
                                                </div>
                                            )}
                                            {(isShowMatbatchflag) && (
                                                <div className="row">
                                                    <Div className="col-md-4" doctype={docType} tagid="gr.item.SLED_BBD" key={`itemModal_${itemModal.item.item_no}_${itemModal.item.date_of_manufacture}_${_startdate}_${_enddate}_${itemModal.onclickdate}`}>
                                                        <div className="rrs-form">
                                                            <div key={`itemModal_${itemModal.item.item_no}_${itemModal.item.sled_bbd}`}>
                                                            {isRequired_SLED_BBD == true ? <span className="required">* </span> : '' }<label htmlFor="sled_bbd" className="rrs-label" id="lbl-gr_item_sled_bbd">SLED BBD </label>
                                                            </div>
                                                            <div className="rrs-detail-data" >
                                                                <DatePickerStartEnd
                                                                    value={itemModal.item.sled_bbd
                                                                        ? moment(itemModal.item.sled_bbd).format('DD/MM/YYYY')
                                                                        : ""}
                                                                    name="sled_bbd"
                                                                    id="sled_bbd"
                                                                    onChange={this.handleChange}
                                                                    onBlur={this.handleChange}
                                                                    doctype={docType}
                                                                    tagid="gr.item.SLED_BBD"
                                                                    viewMode={viewMode}
                                                                    readOnly={true}
                                                                    setStartdate={_startdate}
                                                                    setEnddate={_enddate}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Div>
                                                    <div className="col-md-4">

                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>)}
                                <Div doctype={docType} tagid="gr.head.account_assignment" >
                                    {(itemModal.type === "item" ) && (
                                        <div className="div_account_assignment">
                                            <div className="rrs-detail header-item-acc">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <h5 className="text-header-item-acc">Account Assignment</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <Div doctype={docType} viewMode={viewMode} tagid="gr.item_acc.add" >
                                                <div className="rrs-detail" >
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="rrs-form">
                                                                <label htmlFor="distribution" id="lbl-gr_item_distribution" className="rrs-label">Distribution </label>
                                                                <div className="rrs-detail-data">
                                                                    <Select
                                                                        key={`itemModal_${itemModal.item.item_no}_${itemModal.item.distribution}`}
                                                                        name="distribution"
                                                                        id="distribution"
                                                                        value={itemModal.item.distribution || ''}
                                                                        onChange={this.handleChange}
                                                                        doctype={docType}
                                                                        viewMode={viewMode}
                                                                        tagid="gr.item.distribution"
                                                                        className="distribution">
                                                                        {data_distribution && data_distribution.map((item, index) => (
                                                                            <option key={index} value={item.code}>{item.description}</option>
                                                                        ))}

                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="rrs-form">
                                                                <label htmlFor="partial_inv" id="lbl-gr_item_partial_inv" className="rrs-label">Partial Inv. </label>
                                                                <div className="rrs-detail-data">
                                                                    <Select
                                                                        key={`itemModal_${itemModal.item.item_no}_${itemModal.item.partial_inv}`}
                                                                        name="partial_inv"
                                                                        id="partial_inv"
                                                                        value={itemModal.item.partial_inv || ''}
                                                                        onChange={this.handleChange}
                                                                        doctype={docType}
                                                                        tagid="gr.item.partial_inv"
                                                                        className="partial_inv"
                                                                        viewMode={viewMode}
                                                                    >
                                                                        {/* <option key={0} value={"-"}>{"-"}</option>
                                                            <option key={1} value={"distribute_in_sequence"}>{"Distribute in Sequence"}</option> */}
                                                                        {data_partial_inv && data_partial_inv.map((item, index) => (
                                                                            <option key={index} value={item.code}>{item.description}</option>
                                                                        ))}
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sp-pagination-control-top">
                                                        <Div className="col-auto create-button"
                                                            doctype={docType}
                                                            viewMode={viewMode}
                                                            tagid="gr.item_acc.add">
                                                            {(this.state.accountAssignment && this.state.accountAssignment.length < 99) && (
                                                                <a href="#main" className="sp-bt-addmore" onClick={() => this.newAccountAssignment()}>
                                                                    <i className="icon btn-plus" />
                                                                    <span>เพิ่ม</span>
                                                                </a>)}
                                                            {(this.state.accountAssignment && this.state.accountAssignment.length >= 99) && (
                                                                <React.Fragment>
                                                                    <i className="icon btn-plus opacity" /> <span className="opacity">เพิ่ม</span>
                                                                </React.Fragment>)}
                                                        </Div>

                                                    </div>
                                                </div>
                                            </Div>

                                            <div className="row no-gutters sp-table-content">
                                                <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                                    <TableHead>
                                                        <TableRow className="sp-table-header">
                                                            <Tablecell className="th-table text-center" tagid="gr.item_acc.add" doctype={docType}  width={90} >
                                                                Delete
                                                            </Tablecell>
                                                            {this.state.headAccountAssignment.map((row, index) => (

                                                                <Tablecell
                                                                    tagid={row.tagid}
                                                                    doctype={docType}
                                                                    className="th-table"
                                                                    key={row.id}
                                                                    align={row.numeric ? "right" : "left"}
                                                                    padding={row.disablePadding ? "none" : "default"}
                                                                    sortDirection={this.state.orderBy === row.id ? this.state.order : false}
                                                                    width={row.tagid==='gr.acc_ass.quantity' || row.tagid==='gr.acc_ass.perce'?150:0  }
                                                                >

                                                                    {!row.disableSort && (<TableSortLabel
                                                                        active={this.state.orderBy === row.id}
                                                                        direction={this.state.order}
                                                                        onClick={createSortHandler(row.id)}
                                                                    >
                                                                        <div style={{ width: row.width }} className="th-text">{row.label}</div>
                                                                        {this.state.orderBy === row.id ? (
                                                                            <span
                                                                                style={{
                                                                                    border: 0,
                                                                                    clip: "rect(0 0 0 0)",
                                                                                    height: 1,
                                                                                    margin: -1,
                                                                                    overflow: "hidden",
                                                                                    padding: 0,
                                                                                    position: "absolute",
                                                                                    top: 20,
                                                                                    width: 1
                                                                                }}
                                                                            >
                                                                                {this.state.order === "desc"
                                                                                    ? "sorted descending"
                                                                                    : "sorted ascending"}
                                                                            </span>
                                                                        ) : null}
                                                                    </TableSortLabel>)}

                                                                    {row.disableSort && (
                                                                        <div style={{ width: row.width }} className="th-text">{row.label}</div>
                                                                    )}
                                                                </Tablecell>
                                                            ))}
                                                        </TableRow>

                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.accountAssignment && this.stableSort(this.state.accountAssignment, this.getSorting(this.state.order, this.state.orderBy))
                                                            .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                            .map((row, index) => {
                                                                // if (row.item_no === this.props.itemModal.item.item_no) {
                                                                //     console.log("row.item_no", row.item_no)
                                                                //     console.log("itemModal.item_no", this.state.itemModal.item.item_no)
                                                                return (
                                                                    <TableRow
                                                                        hover
                                                                        tabIndex={-1}
                                                                        key={`itemModal_${itemModal.item.item_no}_${itemModal.item.acc_id}`}
                                                                    >
                                                                        <Tablecell className="action-icon" tagid="gr.item_acc.add" doctype={docType}>
                                                                            <button
                                                                                className="btn"
                                                                                onClick={() => { this.deleteAccountAssignment(row.item_no, row.acc_id) }}
                                                                                disabled={(index === 0 && this.state.page ===0 ? true : false)}
                                                                            >
                                                                                <i className="icon btn-trash" />
                                                                            </button>
                                                                        </Tablecell>
                                                                        <TableCell>
                                                                            <label className="label-full text-grid">{row.acc_id}</label>
                                                                        </TableCell>
                                                                        
                                                                        <Tablecell tagid="gr.acc_ass.quantity" doctype={docType} className="text-right ">
                                                                            {this.state.editQty && (
                                                                                <div key={row.quantity}>
                                                                                    <InputDecimal
                                                                                        type="text"
                                                                                        id="quantity"
                                                                                        name="quantity"
                                                                                        pattern="[0-9.,]*"
                                                                                        defaultValue={numeral(row.quantity).format('0,0.000')}
                                                                                        className="form-control text-right input-acc_ass-qty"
                                                                                        onBlur={(event) => this.handleChangeAccountAssignment(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                        inputMode="decimal"
                                                                                        floatingPoint={3}
                                                                                        step="0,0.000"
                                                                                        doctype={docType}
                                                                                        tagid="gr.acc_ass.quantity"
                                                                                        viewMode={viewMode}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            {!this.state.editQty && (
                                                                                <div></div>
                                                                            )}
                                                                        </Tablecell>
                                                                        <Tablecell tagid="gr.acc_ass.perce" doctype={docType} className="text-right">
                                                                            {this.state.editPerce && (
                                                                                <div key={row.perce}>
                                                                                    <InputDecimal
                                                                                        type="text"
                                                                                        id="perce"
                                                                                        name="perce"
                                                                                        pattern="[0-9.,]*"
                                                                                        defaultValue={numeral(row.perce).format('0,0.00')}
                                                                                        className="form-control text-right input-acc_ass-qty"
                                                                                        autocomplete="off"
                                                                                        onBlur={(event) => this.handleChangeAccountAssignment(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                        inputMode="decimal"
                                                                                        floatingPoint={2}
                                                                                        step="0,0.00"
                                                                                        doctype={docType}
                                                                                        tagid="gr.acc_ass.perce"
                                                                                        viewMode={viewMode}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            {!this.state.editPerce && (
                                                                                <div></div>
                                                                            )}
                                                                        </Tablecell>
                                                                        <Tablecell tagid="gr.acc_ass.gl_acct" doctype={docType}>
                                                                            <DropDownList
                                                                                tagid="gr.acc_ass.gl_acct"
                                                                                doctype={docType}                                                                                
                                                                                name="gl_acct"
                                                                                id={"gl_acct" + index}
                                                                                options={gl_accounts_selectList}
                                                                                onSelectChanged={(event) => this.handleChangeAccountAssignment(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                selected={row.gl_acct}
                                                                                viewMode={viewMode}
                                                                            >
                                                                            </DropDownList>
                                                                        </Tablecell>
                                                                        {this.state.itemModal.item.a === 'F' && (
                                                                            <Tablecell tagid="gr.acc_ass.cost_center" doctype={docType}>
                                                                                <Input
                                                                                    type="text"
                                                                                    name={"cost_center"}
                                                                                    value={row.cost_center || ''}
                                                                                    className={`form-control w-100${viewMode ? '': ' searchable'}`}
                                                                                    autocomplete="off"
                                                                                    id="cost_center"
                                                                                    onChange={(event) => this.handleChangeAccountAssignment(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                    doctype={docType}
                                                                                    tagid="gr.acc_ass.cost_center"
                                                                                    onClick={(event) => this.openCCModal(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                    readOnly={true}
                                                                                    viewMode={viewMode}
                                                                                />
                                                                            </Tablecell>)}
                                                                        {this.state.itemModal.item.a === 'A' && (
                                                                            <Tablecell tagid="gr.acc_ass.asset" doctype={docType}>
                                                                                <Input
                                                                                    tagid="gr.acc_ass.asset"
                                                                                    doctype={docType}
                                                                                    name={"asset"}
                                                                                    id={"asset" + index}
                                                                                    type="text"
                                                                                    className={`form-control w-100${viewMode ? '': ' searchable'}`}
                                                                                    autocomplete="off"
                                                                                    value={row.asset || ''}
                                                                                    onClick={(event) => this.openAssetModal(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                    readOnly={true}
                                                                                    viewMode={viewMode}
                                                                                />
                                                                            </Tablecell>)}
                                                                        <Tablecell tagid="gr.acc_ass.acc_order" doctype={docType}>
                                                                            <Input
                                                                                type="text"
                                                                                name={"acc_order"}
                                                                                value={row.acc_order || ''}
                                                                                className={`form-control w-100${viewMode ? '': ' searchable'}`}
                                                                                autocomplete="off"
                                                                                id="acc_order"
                                                                                onChange={(event) => this.handleChangeAccountAssignment(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                doctype={docType}
                                                                                tagid="gr.acc_ass.acc_order"
                                                                                onClick={(event) => this.openIOModal(event, this.state.page * this.state.rowsPerPage + index)}
                                                                                readOnly={true}
                                                                                viewMode={viewMode}
                                                                            />
                                                                        </Tablecell>
                                                                        <Tablecell tagid="gr.acc_ass.bus_area" doctype={docType}>
                                                                            <Input
                                                                                type="text"
                                                                                name={"business_area"}
                                                                                value={row.business_area || ''}
                                                                                className={`form-control w-100${viewMode ? '' : ' searchable'}`}
                                                                                autocomplete="off"
                                                                                id="business_area"
                                                                                doctype={docType}
                                                                                tagid="gr.acc_ass.bus_area"
                                                                                readOnly={true}
                                                                                viewMode={viewMode}
                                                                            />
                                                                        </Tablecell>
                                                                        <Tablecell tagid="gr.acc_ass.profit_center" doctype={docType}>
                                                                            <Input
                                                                                type="text"
                                                                                name={"profit_center"}
                                                                                value={row.profit_center || ''}
                                                                                className={`form-control w-100${viewMode ? '' : ' searchable'}`}
                                                                                autocomplete="off"
                                                                                id="profit_center"
                                                                                doctype={docType}
                                                                                tagid="gr.acc_ass.profit_center"
                                                                                readOnly={true}
                                                                                viewMode={viewMode}
                                                                            />
                                                                        </Tablecell>
                                                                    </TableRow>
                                                                );

                                                            })}
                                                    </TableBody>
                                                </Table>
                                                <TablePagination
                                                    className="pager"
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={this.state.accountAssignment ? this.getSumAccountAssignment() : 0}
                                                    rowsPerPage={this.state.rowsPerPage}
                                                    page={this.state.page}
                                                    backIconButtonProps={{
                                                        "aria-label": "previous page"
                                                    }}
                                                    nextIconButtonProps={{
                                                        "aria-label": "next page"
                                                    }}
                                                    onChangePage={this.handleChangePage}
                                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                />
                                            </div>
                                        </div>)}
                                </Div>

                                <SearchAssetModal withDummy={true} onSelecctAsset={(value) => this.handleSelectAsset(value)} />
                                <SearchIOModal onSelectIO={(value) => this.handleSelectIO(value)} />
                                {/* <SearchCostCenterModal onSelectCC={(value) => {
                                    this.handleSelectCC(value)
                                }} /> */}
                               
                                <NewAsset
                                    isOpen={showCreateAssetClassType}
                                    onGoBack={() => this.goBack()}
                                    onSaveAsset={this.saveAsset}
                                    plants={this.state.plants}
                                    unit_uoms={this.state.unit_uoms}
                                    assetClasses={this.state.assetClasses}
                                />

                                <div className="rrs-detail pt-3">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 pr-md-5">
                                            <Div className="rrs-form"
                                                doctype={docType}
                                                tagid="gr.item_acc.add"
                                                viewMode={viewMode ||  showCreateAssetClassType}
                                                >
                                               <span  onClick={() => this.createAssetClassType()} className="sp-bt-addmore">
                                                        <i className="icon btn-plus" />
                                                        <span>Create Asset</span>
                                                    </span>
                                            </Div>
                                        </div>
                                    </div>
                                </div>

                                <div className="rrs-detail py-1" style={{ visibility: viewMode ? "hidden" : "visible" }}>
                                    <div className="row sp-table-content-footer" >
                                        <div className="col-10 sp-header-button-panel2"></div>
                                        <div className="col-2 sp-header-button-panel2">
                                            {!this.state.showCreateAssetClassType && (
                                                <React.Fragment>
                                                    <a className="sp-btn-icon btn-del" onClick={this.closeModal} /*data-dismiss="modal"*/>
                                                        <i className="icon btn-order-delete" />
                                                        <span className="sp-btn-icon-label">Close</span>
                                                    </a>
                                                    <a className="sp-btn-icon" onClick={this.saveItem}>
                                                        <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Save</span>
                                                    </a>
                                                </React.Fragment>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux } = state
    return {
        viewMode: MainRedux.viewMode,
        po_no: MainRedux.po_no,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_NEW_ASSET: MainRedux.t_NEW_ASSET,
        currency_code_data: MasterRedux.currency_codes,
        storage_locations: MasterRedux.storage_locations,
        itemModal: MainRedux.itemModal
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateGR_ItemModal: (data) => dispatch(updateGR_ItemModalAction(data)),
        updateGR_Item: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAction(data, index, fieldName)),
        updateGR_Service: (data, index = "", fieldName = "") => dispatch(updateGR_ServiceAction(data, index, fieldName)),
        updateGR_ItemAccountAssignment: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName)),
        getCostCenter: () => dispatch(getCostCenterAction(null, null, null)),
        getGLAccount: () => dispatch(getGLAccountAction(null, null, null)),
        updateNewAsset: (assetNew) =>dispatch(updateNewAssetAction(assetNew)),
        setAssetModalOption: (options) => dispatch(setAssetModalOptionAction(options)),
        setModalCostCenterKey :(refKey) => dispatch(setModalCostCenterKeyAction(refKey)),
        getMatBatchFlag:(material_no, plant, offset, limit) => dispatch(getMatBatchFlagAction(material_no, plant, offset, limit)),
        
        getPlantInfo: (purOrg) => dispatch(getPlantInfoAction(purOrg)),
        getUOM: () => dispatch(getUOMAction()),
        getAssetClass: () => dispatch(getAssetClassAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemModal)